const GaliStatusPill = ({ status = 'draft' }) => <span className={`gali-pill gali-pill-${String(status).replace(/\s+/g, '_')}`}>{String(status || 'draft').replace(/_/g, ' ')}</span>;
export default GaliStatusPill;
